<layout>
  <top-bar>
    <sub-navigation>
      <sub-navigation-item path="/dashboard">{{ 'TAB.DASHBOARD' | translate }}</sub-navigation-item>
    </sub-navigation>
  </top-bar>
  <left-panel [isExpanded]="true">
    <container verticalHeight="fill" [isScrollable]="true">
      @if (!$isFullscreenChart() && $account()) {
        <div [class]="routingService.$isMobile() ? 'hello-card hello-card-mobile' : 'hello-card'">
          @if ($account()?.firstname) {
            <p class="hello-title">
              {{ 'DASHBOARD.HELLO' | translate: { value: $account().firstname } }}
            </p>
          }

          <div class="container-btn">
            @if ($isEditDash()) {
              <button matButton="filled" [matMenuTriggerFor]="menu">
                <mat-icon>add</mat-icon>
                {{ 'DASHBOARD.ADD_CARDS' | translate }}
              </button>
              <button (click)="resetOptions()" matButton="outlined">
                <mat-icon>autorenew</mat-icon>
                {{ 'COMMON.RESET' | translate }}
              </button>
              <button (click)="toggleEdit()" matButton="tonal">
                <mat-icon>done</mat-icon>
                {{ 'COMMON.COMPLETE' | translate }}
              </button>
            } @else {
              <!--  Quick Actions -->
              @if (quickActions.length > 1) {
                <button matButton="filled" class="accent" [matMenuTriggerFor]="quickMenu">
                  <mat-icon>add_circle</mat-icon>
                  {{ 'DASHBOARD.CREATE' | translate }}
                </button>
                <mat-menu #quickMenu="matMenu">
                  @for (quickAction of quickActions; track $index) {
                    <button [routerLink]="quickAction.path" mat-menu-item>
                      {{ 'DASHBOARD.QUICK_ACTIONS.' + quickAction.key | translate }}
                    </button>
                  }
                </mat-menu>
              } @else if (quickActions.length === 1) {
                <button matButton="filled" color="accent">
                  {{ 'DASHBOARD.QUICK_ACTIONS.' + quickActions[0].key | translate }}
                </button>
              }
              <!--  Quick Actions END -->
              <button (click)="toggleEdit()" matButton="tonal">
                <mat-icon>edit</mat-icon>
                {{ 'DASHBOARD.MANAGE_CARDS' | translate }}
              </button>
            }
          </div>
          <mat-menu #menu="matMenu">
            @for (choice of $newCardChoices(); track choice) {
              <button mat-menu-item (click)="addCard(choice)">
                {{ 'DASHBOARD.WIDGET.' + (choice | uppercase) | translate }}
              </button>
            }
          </mat-menu>
        </div>
        @if ($displayableCards().length > 0) {
          <div class="dash-cards" [cdkDropListGroupDisabled]="!$isEditDash()" cdkDropListGroup>
            @for (displayableCard of $displayableCards(); track displayableCard.card) {
              @let card = displayableCard.card;
              @let index = displayableCard.index;
              <div
                cdkDropList
                cdkDropListOrientation="horizontal"
                [cdkDropListData]="index"
                (cdkDropListDropped)="drop($event)">
                <mat-card class="card-drag" cdkDrag>
                  @if (card?.card) {
                    @switch (card.card) {
                      @case ('map') {
                        @if ($isEditDash()) {
                          <mat-icon
                            (click)="destroy(index)"
                            class="card-option card-option-map"
                            [matTooltip]="'COMMON.DELETE' | translate">
                            delete
                          </mat-icon>
                        }
                        <widget-map />
                        <ng-container *cdkDragPreview>
                          <div class="card-map-preview">
                            <mat-icon class="material-icons">map</mat-icon>
                            <p>{{ 'COMMON.MAP' | translate }}</p>
                          </div>
                        </ng-container>
                      }
                      @case (['state', 'maintenance-state'].includes(card.card) ? card.card : !card.card) {
                        @if ($isEditDash()) {
                          <mat-icon
                            (click)="destroy(index)"
                            class="card-option"
                            [matTooltip]="'COMMON.DELETE' | translate">
                            delete
                          </mat-icon>
                        }
                        <widget-state [isEdit]="$isEditDash()" [card]="card" [index]="index" />
                      }
                      @case ('poi') {
                        @if ($isEditDash()) {
                          <mat-icon
                            (click)="destroy(index)"
                            class="card-option"
                            [matTooltip]="'COMMON.DELETE' | translate">
                            delete
                          </mat-icon>
                        }
                        <widget-poi [isDashboard]="true" />
                      }
                      @case ('tripless') {
                        @if ($isEditDash()) {
                          <mat-icon
                            (click)="destroy(index)"
                            class="card-option"
                            [matTooltip]="'COMMON.DELETE' | translate">
                            delete
                          </mat-icon>
                        }
                        <widget-immobilized-device [isEdit]="$isEditDash()" [card]="card" [index]="index" />
                      }
                      @case ('private') {
                        @if ($isEditDash()) {
                          <mat-icon
                            (click)="destroy(index)"
                            class="card-option"
                            [matTooltip]="'COMMON.DELETE' | translate">
                            delete
                          </mat-icon>
                        }
                        <widget-private />
                      }
                      @case ('maintenance') {
                        @if ($isEditDash()) {
                          <mat-icon
                            (click)="destroy(index)"
                            class="card-option"
                            [matTooltip]="'COMMON.DELETE' | translate">
                            delete
                          </mat-icon>
                        }
                        <widget-maintenance />
                      }
                      @case ('diagnostic') {
                        @if ($isEditDash()) {
                          <mat-icon
                            (click)="destroy(index)"
                            class="card-option"
                            [matTooltip]="'COMMON.DELETE' | translate">
                            delete
                          </mat-icon>
                        }
                        <widget-diagnostic />
                      }
                      @case ('news') {
                        @if ($isEditDash()) {
                          <mat-icon
                            (click)="destroy(index)"
                            class="card-option"
                            [matTooltip]="'COMMON.DELETE' | translate">
                            delete
                          </mat-icon>
                        }
                        <widget-news />
                      }
                      @case ('poitovalidate') {
                        @if ($isEditDash()) {
                          <mat-icon
                            (click)="destroy(index)"
                            class="card-option"
                            [matTooltip]="'COMMON.DELETE' | translate">
                            delete
                          </mat-icon>
                        }
                        <widget-validate-poi />
                      }
                      @case ('lockeddevices') {
                        @if ($isEditDash()) {
                          <mat-icon
                            (click)="destroy(index)"
                            class="card-option"
                            [matTooltip]="'COMMON.DELETE' | translate">
                            delete
                          </mat-icon>
                        }
                        <widget-locked-device />
                      }
                      @case ('alarm-logs') {
                        @if ($isEditDash()) {
                          <mat-icon
                            (click)="destroy(index)"
                            class="card-option"
                            [matTooltip]="'COMMON.DELETE' | translate">
                            delete
                          </mat-icon>
                        }
                        <widget-alarm-log />
                      }
                    }
                  } @else {
                    @if ($initCharts()) {
                      <chart
                        [id]="'chart-' + index"
                        [isEditDash]="$isEditDash()"
                        [config]="card"
                        [index]="index"
                        [fullscreen]="$isFullscreenChart()" />
                    }
                  }
                </mat-card>
              </div>
            }
          </div>
        }
      }

      @if ($config(); as config) {
        @if ($isFullscreenChart() && !routingService.$isMobile()) {
          <div class="dash-card-fullscreen">
            @if (!!config) {
              <chart
                [isEditDash]="$isEditDash()"
                [config]="config"
                [index]="tripStatsService.index"
                [fullscreen]="$isFullscreenChart()" />
            }
          </div>
        }
      }
    </container>
  </left-panel>
</layout>
